module.exports = __webpack_public_path__ + "img/no-photo-animals.ade84c0d.jpg";